import { SERVER_API } from "../../Constant";
import axios from "axios";

export const UpdatePayments = async (data: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(data));
        const response = await axios.post(
            `${SERVER_API}/Payments/update_payment_data.php`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Update payments failed:", error);
        return { error: "Update payments failed" };
    }
};
